import { Block } from "../../../rpcs/dist/EpisodeRPC"

export const convertOBlocksToText = (OBlocks: Block[]) =>
  OBlocks.map(block => block.text).join("\n")
